<template>
  <div>
    <el-row>
      <el-col :span="18">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1 && currentOrderFlag == 0">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择" clearable style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false"
              style="width: 200px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分组：">
            <el-select v-model="searchForm.GROUP_IDS" multiple filterable placeholder="请选择分组" clearable style="width: 200px;">
              <el-option v-for="item in projectGroupList" :key="item.GROUP_ID" :label="item.PROJECT_GROUP" :value="item.GROUP_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable">筛选</el-button>
            <el-button @click="gotoSeparateRemarks" style="float:right">分菜单备注</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" plain style="margin: -5px 20px 10px 10px;" @click="openExprotSupplierForm"
          v-show="fun_dic[125010101]">带供应商导出</el-button>
        <el-button type="primary" plain style="margin: -5px 20px 10px 10px;" @click="openExprotForm">导出</el-button>
        <el-button type="primary" plain style="margin: 5px 20px 10px 10px;" @click="openExprotByProjectForm"
          v-if="!currentOrderFlag">按项目导出分拣单</el-button>
        <el-button type="primary" plain style="margin: 5px 20px 10px 10px;" @click="openExprotByDeclareTypeForm"
          v-show="fun_dic[125010102]">按报货方案导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick">
          <el-tab-pane label="团餐客户">
            <el-table stripe border :data="tableData" style="margin-top:20px">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="分类名称" prop="CATALOG_NAME"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text">查看明细</el-button>
                  <el-button @click="exportDetail(scope.row, 0)" type="text">导出明细(不显示编码)</el-button>
                  <el-button @click="exportDetail(scope.row, 1)" type="text">导出明细(显示编码)</el-button>
                  <el-button @click="printTotal(scope.row)" type="text">打印汇总</el-button>
                  <el-button @click="printDetail(scope.row)" type="text">打印明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商客户">
            <el-table stripe border :data="tableData" style="margin-top:20px">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="分类名称" prop="CATALOG_NAME"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text">查看明细</el-button>
                  <el-button @click="exportDetail(scope.row, 0)" type="text">导出明细(不显示编码)</el-button>
                  <el-button @click="exportDetail(scope.row, 1)" type="text">导出明细(显示编码)</el-button>
                  <el-button @click="printTotal(scope.row)" type="text">打印汇总</el-button>
                  <el-button @click="printDetail(scope.row)" type="text">打印明细</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <!-- 按项目导出分拣单 -->
    <el-dialog title="按项目导出分拣单" center :visible.sync="exportByProjectVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" :model="exportByProjectForm" ref="exportByProjectForm" style="margin-top: 0">
        <el-form-item label="客户 ：" label-width="100px" prop="GROUP">
          <!--          <el-select v-model="exportByProjectForm.TC_ID_LIST" multiple filterable placeholder="请选择" clearable-->
          <!--            @keyup.enter.native="exportByProject">-->
          <!--            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID">-->
          <!--              <span style="float: left">{{ item.AB_NAME }}</span>-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-select v-model="exportByProjectForm.TC_ID_LIST" multiple filterable placeholder="请选择" clearable @keyup.enter.native="exportByProject">
            <el-option v-for="(item, index) in companys" :key="item.ID + index" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left">{{ item.AB_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="副仓：" label-width="100px" v-if="subWarehouseList && subWarehouseList.length > 1">
          <el-select v-model="exportByProjectForm.SUB_WAREHOUSE" filterable placeholder="请选择" @change="exportSubWarehouseChange" clearable>
            <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分拣组：" label-width="100px" prop="GROUP">
          <el-select v-model="exportByProjectForm.GROUP" multiple filterable placeholder="请选择" clearable @keyup.enter.native="exportByProject">
            <el-option v-for="item in groupList" :key="item.ID" :label="item.GROUP_NAME" :value="item.ID">
              <span style="float: left">{{ item.GROUP_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类：" label-width="100px" prop="CATALOG">
          <el-select v-model="exportByProjectForm.CATALOG" filterable placeholder="请选择" clearable multiple @keyup.enter.native="exportByProject">
            <el-option v-for="item in catalogListByProject" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              <!-- <span style="float: left">{{ item.GROUP_NAME }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报货方案：" label-width="100px" prop="CATALOG">
          <el-select v-model="exportByProjectForm.purchasePlan" filterable placeholder="请选择" clearable multiple>
            <el-option v-for="item in PlanList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportByProjectVisible = false">取 消</el-button>
        <el-button size="small" @click="exportByProject">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出分拣单 -->
    <el-dialog title="按项目导出分拣单" center :visible.sync="exportVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="exportForm" ref="exportForm" style="margin-top: 0" label-width="100px">
        <el-form-item label="送货日期：" prop="DAY_INTERVAL">
          <el-date-picker v-model="exportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分类：" prop="CATALOG">
          <el-select v-model="exportForm.CATALOG" filterable placeholder="请选择" clearable multiple @keyup.enter.native="exportByProject"
            style="width: 100%;">
            <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组：">
          <el-select v-model="exportForm.GROUP_IDS" multiple filterable placeholder="请选择分组" clearable style="width: 100%;">
            <el-option v-for="item in projectGroupList" :key="item.GROUP_ID" :label="item.PROJECT_GROUP" :value="item.GROUP_ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportVisible = false">取 消</el-button>
        <el-button size="small" @click="exportExcel">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 带供应商导出 -->
    <el-dialog title="带供应商导出" center :visible.sync="exportSupplierVisible" width="620px" :close-on-click-modal="false">
      <el-form size="small" :model="exportSupplierForm" ref="exportSupplierForm" style="margin-top: 0">
        <el-form-item label="日期范围：" label-width="150px" prop="DATE_RANGE">
          <el-date-picker v-model="exportSupplierForm.DATE_RANGE" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="是否带供应商导出：" label-width="150px" prop="IS_WITH_SUPPLIER" style="margin-left: 55px">
          <el-radio v-model="exportSupplierForm.IS_WITH_SUPPLIER" label="1">是</el-radio>
          <el-radio v-model="exportSupplierForm.IS_WITH_SUPPLIER" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="是否是供应链客户：" label-width="150px" prop="IS_SUPPLY_CHAIN" style="margin-left: 55px">
          <el-radio v-model="exportSupplierForm.IS_SUPPLY_CHAIN" label="1">是</el-radio>
          <el-radio v-model="exportSupplierForm.IS_SUPPLY_CHAIN" label="0">否</el-radio>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportSupplierVisible = false">取 消</el-button>
        <el-button size="small" @click="exportSupplierExcel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="按报货方案导出" center :visible.sync="exportByDeclareTypeVisible" width="450px" :close-on-click-modal="false">
      <el-form size="small" :model="exportSupplierForm" ref="exportSupplierForm" style="margin-top: 0">
        <el-form-item label="日期范围：" label-width="100px" prop="DATE_RANGE">
          <el-date-picker v-model="exportByDeclareTypeForm.DATE_RANGE" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" format="yyyy-MM-dd"
            style="width:80%"></el-date-picker>
        </el-form-item>
        <el-form-item label="报货方案：" label-width="100px" prop="CATALOG">
          <el-select v-model="exportByDeclareTypeForm.DECLARE_TYPE_ID" filterable placeholder="请选择" clearable style="width:80%">
            <el-option v-for="item in PlanList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportByDeclareTypeVisible = false">取 消</el-button>
        <el-button size="small" @click="exportByDeclareType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import { selectTCFun } from '@/assets/api/sellOrder';
import date from '@/assets/common/date';
import http from '@/assets/common/http';
import { getFormatDay, print } from '@/assets/common/common';
import { getClientGroupFun } from '@/assets/api/systemSetting';

export default {
  data() {
    return {
      companys: [],
      PAGE_ID: '1250101', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 125010101: 0, 125010102: 0 },
      searchForm: {
        date: getFormatDay(1, '-'),
        STATUS: '0',
        GROUP_IDS: [],
      },
      tableData: [],
      name: '',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      PlanList: [],
      statusList: [
        {
          ID: '0',
          NAME: '未处理',
        },
        {
          ID: '1',
          NAME: '已处理',
        },
      ],
      currentOrderFlag: 0,
      exportByProjectVisible: false,
      exportByProjectForm: {},
      exportVisible: false,
      exportForm: {
        DAY_INTERVAL: [],
        GROUP_IDS: [],
      },
      groupList: [],
      catalogList: [],
      // 带供应商导出
      exportSupplierVisible: false,
      exportByDeclareTypeVisible: false,
      exportSupplierForm: {
        IS_WITH_SUPPLIER: '1',
        IS_SUPPLY_CHAIN: '0',
      },
      exportByDeclareTypeForm: {
        DATE_RANGE: [date((Date.now()) + 24 * 60 * 60 * 1000, '%F'), date((Date.now()) + 24 * 60 * 60 * 1000, '%F')],
        DECLARE_TYPE_ID: '',
      },
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      catalogListByProject: [],
      projectGroupList: [],
    };
  },
  created() {
    // 拉取报货方案
    this.queryPurchasePlan();
    // 获取团餐客户列表
    this.queryCustomer();
    this.queryProjectGroup();
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (JSON.stringify(this.SORT_SEARCH) !== '{}' && JSON.stringify(this.SORT_SEARCH) !== undefined) {
      this.searchForm = this.SORT_SEARCH;
      this.queryTable();
    } else {
      this.searchForm.date = getFormatDay(1, '-');
      this.queryTable();
    }
    this.querySortingGroup();
    this.queryBeforeFun();
    // this.searchForm = this.$store.getters.SORT_SEARCH;
  },
  computed: {
    SORT_SEARCH() {
      return this.$store.state.SORT_SEARCH;
    },
  },
  methods: {
    // 获取客户列表
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          const uniqueCompanies = [];
          const uniqueIds = new Set();
          for (const item of result[0].company) {
            if (!uniqueIds.has(item.ID)) {
              uniqueIds.add(item.ID);
              uniqueCompanies.push(item);
            }
          }
          this.companys = uniqueCompanies;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 拉取 报货方案
    queryPurchasePlan() {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 13,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result[0].OP_ROLE.length !== 0) {
          this.PlanList = result[0].OP_ROLE;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // ----------------------------拉取数据
    queryTable() {
      if (!this.searchForm.date) {
        this.$message.show({ text: '请选择送货日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        SEND_DAY: this.searchForm.date,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.SUB_WAREHOUSE) {
        params.SUB_SUPPLIER_ID = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.GROUP_IDS && this.searchForm.GROUP_IDS.length) params.GROUP_IDS = this.searchForm.GROUP_IDS;
      this.loading = true;
      http.post(params).then((result) => {
        this.tableData = result;
        this.loading = false;
        this.$store.dispatch('SET_SORT_SEARCH', this.searchForm);
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------导出
    exportExcel() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10022',
            OTYPE: 7,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SEND_DAY: date(this.searchForm.date, '%F'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            START_DAY: this.exportForm.DAY_INTERVAL[0],
            END_DAY: this.exportForm.DAY_INTERVAL[1],
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (this.exportForm.CATALOG && this.exportForm.CATALOG.length) {
            params.CATALOG_ID_LIST = this.exportForm.CATALOG;
          }
          if (this.exportForm.GROUP_IDS && this.exportForm.GROUP_IDS.length) params.GROUP_IDS = this.exportForm.GROUP_IDS;
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 带供应商导出
    openExprotSupplierForm() {
      this.exportSupplierVisible = true;
    },
    openExprotByDeclareTypeForm() {
      this.exportByDeclareTypeVisible = true;
    },
    exportSupplierExcel() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!this.exportSupplierForm.DATE_RANGE) {
            this.$message.show({ text: '请选择导出的日期范围', type: 'warning' });
            document.body.style.cursor = 'default';
            return;
          }
          const params = {
            SERVICE_ID: '10022',
            OTYPE: 7,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            START_DAY: this.exportSupplierForm.DATE_RANGE[0],
            END_DAY: this.exportSupplierForm.DATE_RANGE[1],
          };
          if (this.searchForm.date) {
            params.SEND_DAY = date(this.searchForm.date, '%F');
          }
          if (this.currentOrderFlag == 0) {
            params.EXPORT_WITH_SUPPLIER = 1;
            params.IS_SUPPLIER_CLIENT = 0;
          }
          if (this.currentOrderFlag == 1) {
            params.EXPORT_WITH_SUPPLIER = 1;
            params.IS_SUPPLIER_CLIENT = 1;
          }
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportSupplierVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 按备货周期导出
    exportByDeclareType() {
      if (!(this.exportByDeclareTypeForm.DATE_RANGE != null && this.exportByDeclareTypeForm.DATE_RANGE.length == 2)) {
        this.$message.show({ text: '请选择导出的日期范围', type: 'warning' });
        return;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10022',
            OTYPE: 70,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            START_DAY: this.exportByDeclareTypeForm.DATE_RANGE[0],
            END_DAY: this.exportByDeclareTypeForm.DATE_RANGE[1],
          };
          if (this.currentOrderFlag == 0) {
            params.EXPORT_WITH_SUPPLIER = 1;
            params.IS_SUPPLIER_CLIENT = 0;
          }
          if (this.currentOrderFlag == 1) {
            params.EXPORT_WITH_SUPPLIER = 1;
            params.IS_SUPPLIER_CLIENT = 1;
          }
          if (this.exportByDeclareTypeForm.DECLARE_TYPE_ID) {
            params.DECLARE_TYPE_ID = this.exportByDeclareTypeForm.DECLARE_TYPE_ID;
          }
          http.post(params)
            .then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              this.exportByDeclareTypeVisible = false;
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
        }
      }
    },

    openTotal(row) {
      this.$router.push({ name: 'totalPurchase' });
      sessionStorage.setItem('kindId', row.CATALOG_ID);
      sessionStorage.setItem('sendDay', this.searchForm.date);
    },
    openDetail(row) {
      this.$router.push({ name: 'separateDetail', params: { GROUP_IDS: this.searchForm.GROUP_IDS } });
      sessionStorage.setItem('subWarehouseId', this.searchForm.SUB_WAREHOUSE || '');
      sessionStorage.setItem('kindId', row.CATALOG_ID);
      sessionStorage.setItem('sendDay', this.searchForm.date);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    exportTotal(row) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: this.searchForm.SUB_WAREHOUSE || sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
      };
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportDetail(row, num) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: this.searchForm.SUB_WAREHOUSE || sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
        SHOW_CODE: num,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.GROUP_IDS && this.searchForm.GROUP_IDS.length) params.GROUP_IDS = this.searchForm.GROUP_IDS;
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.queryTable();
    },
    printTotal(row) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 8,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: this.searchForm.SUB_WAREHOUSE || sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.GROUP_IDS && this.searchForm.GROUP_IDS.length) params.GROUP_IDS = this.searchForm.GROUP_IDS;
      http.post(params).then((result) => {
        const printArr = result[0].DATA[0].DATA.map((item) => {
          if (item.T - item.W <= 0) {
            return Object.assign(item, { SUGGEST: 0 });
          }
          return Object.assign(item, { SUGGEST: Math.round((item.T - item.W) * 100) / 100 });
        });
        let html = '<div>';
        html += '<div class="main">';
        html += '<div class="title"  style="font-size: 18px"><b>分菜单汇总</b></div>';
        html += `<div class="head"><div class="code">日期：${date(this.searchForm.date, '%F')}</div><div>分类：${row.CATALOG_NAME}</div></div>`;
        html += '<table border="1" cellspacing="0" style="font-size: 13px"><div class="el-table__body el-table__header">';
        html += '<tr><th style="width: 40px">序号</th> <th>产品</th> <th  style="width: 50px">单位</th> <th style="width: 60px">订购数量</th><th>备注</th><th style="width: 60px">实际购买</th><th style="width: 60px">价格</th><th style="width: 60px">付款金额</th></tr>';
        html += '</div><div class="el-table__body">';
        printArr.forEach((item, index) => {
          html += '<tr style="text-align: center">';
          html += `<td> ${index + 1} </td> <td>${item.N}</td> <td>${item.U}</td>
                  <td>${item.T}</td><td></td><td></td><td></td><td></td>`;
          html += '</tr>';
        });
        html += '</div>';
        html += '</table>';
        html += '</div>';
        html += '</div>';
        const windows = print(html);
        windows.close();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    printDetail(row) {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 9,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: date(this.searchForm.date, '%F'),
        SUPPLIER_ID: this.searchForm.SUB_WAREHOUSE || sessionStorage.getItem('tcId'),
        CATALOG_ID: row.CATALOG_ID,
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.GROUP_IDS && this.searchForm.GROUP_IDS.length) params.GROUP_IDS = this.searchForm.GROUP_IDS;
      http.post(params).then((result) => {
        const printArr = result[0].DATA[0].DATA;
        let totalPrintFee = 0;
        result[0].DATA[0].DATA.forEach((item) => {
          totalPrintFee += Number(item.PRODUCT_COUNT);
        });
        let html = '<div>';
        html += '<div class="main">';
        html += '<div class="title" style="font-size: 18px"><b>分菜单明细</b></div>';
        html += `<div class="head" style="font-size: 14px"><div class="code">日期：${date(this.searchForm.date, '%F')}</div><div>分类：${row.CATALOG_NAME}</div></div>`;
        html += '<table border="1" cellspacing="0" style="font-size: 13px"><div class="el-table__body el-table__header">';
        html += '<tr><th style="width: 40px">序号</th> <th>项目点</th> <th>档口</th> <th>产品</th> <th  style="width: 40px">单位</th> <th style="width: 60px">订购数量</th><th>备注</th></tr>';
        html += '</div><div class="el-table__body">';
        printArr.forEach((item, index) => {
          html += '<tr style="text-align: center">';
          html += `<td> ${index + 1} </td> <td>${item.PROJECT_NAME}</td> <td>${item.DK_NAME}</td><td>${item.PRODUCT_NAME}</td>
                  <td>${item.TYPE_UNIT}</td> <td>${item.PRODUCT_COUNT}</td> <td>${item.PRODUCT_COMMENT}</td>`;
          html += '</tr>';
        });
        html += '</div>';
        html += '</table>';
        html += `<div class="footer" style="font-size: 14px"><div class="code" style="float: right">总量合计：${Math.round(totalPrintFee * 100) / 100}</div></div>`;
        html += '</div>';
        html += '</div>';
        const windows = print(html);
        windows.close();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoSeparateRemarks() {
      const ddate = this.searchForm.date !== null ? this.searchForm.date : date(new Date(), '%F');
      this.$router.push({ path: `/separateRemarks/${ddate}`, params: { date: ddate } });
    },
    openExprotByProjectForm() {
      if (!this.searchForm.date) {
        this.$message.show({ text: '请先选择送货日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 6,
        SUPPLIER_ID: this.exportByProjectForm.SUB_WAREHOUSE || Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.catalogListByProject = res;
        this.exportByProjectVisible = true;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    exportByProject() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 23,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.searchForm.date,
      };
      if (this.exportByProjectForm.GROUP && this.exportByProjectForm.GROUP.length) {
        params.GROUP_ID = this.exportByProjectForm.GROUP;
      }
      if (this.exportByProjectForm.CATALOG && this.exportByProjectForm.CATALOG.length) {
        params.CATALOG_ID_LIST = this.exportByProjectForm.CATALOG;
      }
      if (this.exportByProjectForm.SUB_WAREHOUSE) {
        params.SUB_SUPPLIER_ID = this.exportByProjectForm.SUB_WAREHOUSE;
      }
      if (this.exportByProjectForm.TC_ID_LIST && this.exportByProjectForm.TC_ID_LIST.length) {
        params.TC_ID_LIST = this.exportByProjectForm.TC_ID_LIST;
      }
      if (this.exportByProjectForm.purchasePlan && this.exportByProjectForm.purchasePlan.length) {
        params.DECLARE_ID_LIST = this.exportByProjectForm.purchasePlan;
      }
      http.post(params).then((res) => {
        if (res.fileURL) {
          this.$message.show({ text: '导出成功', type: 'success' });
          window.location.href = this.$util.getURLLocalHost(res.fileURL);
          this.exportByProjectVisible = false;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    // 拉取分拣组
    querySortingGroup() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 18,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.groupList = result.LIST;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openExprotForm() {
      if (!this.searchForm.date) {
        this.$message.show({ text: '请先选择送货日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 6,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.catalogList = res;
        this.exportForm.DAY_INTERVAL = [this.searchForm.date, this.searchForm.date];
        this.exportVisible = true;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    exportSubWarehouseChange() {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 6,
        SUPPLIER_ID: this.exportByProjectForm.SUB_WAREHOUSE || sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.catalogListByProject = res;
      }).catch((err) => { this.$message.show({ text: err, type: 'error' }); });
    },
    queryProjectGroup() {
      getClientGroupFun().then((result) => {
        this.projectGroupList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.product {
  color: #606266;
  padding-left: 5px;
  height: 40px;
}

.table-title {
  height: 50px;
  line-height: 50px;
  border: 1px solid #ebeef5;
  color: #909399;
  font-weight: bold;
  border-bottom: 0;
}

.table-line {
  float: left;
  width: 50%;
}

.sending,
.sending tr th,
.sending tr td {
  border: 1px solid #ebeef5;
}

.product-title {
  border-top: 0 !important;
  border-bottom: 0 !important;
  color: #606266;
  padding-left: 5px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/separateDoc.vue